// Module
var code = "<div> <button class=\"ui small basic button\" ng-click=\"meetsCreate.addMeets();\"> <div class=\"flexgrid\"> <span><i class=\"icon meets small\"></i></span> <span>Enable Google Meets</span> </div> </button> </div>";
// Exports
module.exports = code;